export enum EDataUnit {
  WATT_HOUR = "Wh",
  CELSIUS_DEGREE = "CELSIUS",
  EURO = "€",
  PERCENT = "%",
  KG = "kg",
  SQUARE_METER = "m²",
}
